// Styles
import "@mdi/font/css/materialdesignicons.css";
// Vuetify
import { createVuetify } from "vuetify";
import { VCheckbox, VDataTable, VTabs } from "vuetify/components";
import { VDateInput } from "vuetify/labs/VDateInput";
import { VTimePicker } from "vuetify/labs/VTimePicker";
import "vuetify/styles";

export default createVuetify({
  components: {
    VDataTable,
    VTabs,
    VDateInput,
    VTimePicker,
    VCheckbox,
  },
  theme: {
    defaultTheme: "myTheme",
    themes: {
      myTheme: {
        colors: {
          background: "#EEEEEE",
        },
      },
    },
  },
});
